import { useAppContext } from '@pkgs/components/hooks/useAppContext';
import { useAutoCompleteStore } from '@pkgs/components/hooks/stores/useAutoCompleteStore';
import { usePromptStore } from '@pkgs/components/hooks/stores/search/usePromptStore';
import { useAiSearch } from '@pkgs/components/hooks/queries/useAiSearch';
import { SearchGradient } from '@pkgs/components/assets/icons/small/SearchGradient';
import SearchIcon from '@pkgs/components/assets/icons/small/Search.svg';
import { Button } from '@ev-tech/ui-core-components/Button';

import styles from '../AiLocationFilter/AiLocationFilter.module.css';

export const MobileAiSearchButton = ({ temporaryPromptValue }: { temporaryPromptValue: string }) => {
  const { t } = useAppContext();
  const { isPending } = useAiSearch();
  const promptValue = usePromptStore((state) => state.promptValue);
  const hasPendingFilterChanges = useAutoCompleteStore((state) => Boolean(state.aiDraftState));
  const setIsMobileModalOpen = useAutoCompleteStore((state) => state.setIsMobileModalOpen);

  const hasPromptChanges = promptValue.trim() !== temporaryPromptValue.trim();

  if (!hasPromptChanges && !hasPendingFilterChanges) {
    return (
      <Button
        className={styles.aiSearchTextButton}
        variant="tertiary"
        type="button"
        label={t('search.aiSearch.filtersDropdown.backToResults')}
        onClick={() => setIsMobileModalOpen(false)}
      />
    );
  }

  return (
    <Button
      className={styles.aiSearchTextButton}
      icon={temporaryPromptValue.trim().length < 3 ? <SearchIcon /> : <SearchGradient />}
      variant="tertiary"
      disabled={(hasPromptChanges && temporaryPromptValue.trim().length < 3) || isPending}
      label={t('search.aiSearch.mobile.searchButton')}
      type="submit"
    />
  );
};
